import * as React from "react";
const SvgLine = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M37.5639 13.5578C38.1454 12.9764 38.1454 12.0199 37.5639 11.4385C36.9825 10.8571 36.026 10.8571 35.4446 11.4385L23.0008 23.8824L15.0581 15.9397C14.4767 15.3583 13.5202 15.3583 12.9388 15.9397L2.43605 26.4424C1.85465 27.0238 1.85465 27.9803 2.43605 28.5617C3.01745 29.1431 3.97395 29.1431 4.55535 28.5617L13.9984 19.1186L21.9411 27.0613C22.5225 27.6427 23.479 27.6427 24.0604 27.0613L37.5639 13.5578Z" }));
export default SvgLine;
